module.exports = __webpack_public_path__ + "static/media/icn-in.4e28f746.svg";